export enum OrderStatus {
    New = 0,
    Completed = 1,
    Request = 4,
    Rejected = 6,
    Deleted = 8
}
